export default function TelegramIcon({ width = 22, height = 17, className, style }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            style={style}
            aria-hidden="true"
        >
            <path
                d="M9.417 15.181l-.397 5.584c.568 0 .814-.244 1.109-.537l2.663-2.545 5.518 4.041c1.012.564 1.725.267 1.998-.931L23.93 3.821c.321-1.496-.541-2.081-1.527-1.717L1.293 9.821c-1.453.564-1.431 1.373-.262 1.742l5.722 1.787L18.29 6.061c.6-.397 1.146-.179.697.261"
                fill="#EAEAEA"
            />
        </svg>
    );
}
